import React from 'react'

const PageNotFound = () =>
  <div className="container">
    {/* <h1 className="glitch" data-text="Page Not Found">Page Not Found</h1> */}
    <div className="client-quote">
      <blockquote>
        Oops – page not found (404)
      </blockquote>
    </div>
  </div>

export default PageNotFound



// WEBPACK FOOTER //
// src/javascripts/pages/PageNotFound.js